import {
	Component,
	Input,
	ElementRef,
	ViewChild,
	OnChanges,
	SimpleChanges,
	Renderer2
} from '@angular/core';

@Component({
	selector: 'app-pos-viewer',
	templateUrl: './pos-viewer.component.html',
	styleUrls: ['./pos-viewer.component.scss']
})
export class PosViewerComponent implements OnChanges {
  @Input() htmlContent = '';
  @ViewChild('renderTarget', { static: true }) renderTarget!: ElementRef;

  constructor(private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
  	if (changes['htmlContent'] && this.htmlContent) {
	  this.renderHtml(this.htmlContent);
  	}
  }

  private renderHtml(rawHtml: string): void {
  	const parser = new DOMParser();
  	const doc = parser.parseFromString(rawHtml, 'text/html');

  	const container = this.renderTarget.nativeElement;
  	container.innerHTML = ''; // Clear previous render

  	// Strip inline styles
  	Array.from(doc.querySelectorAll('[style]')).forEach(el => el.removeAttribute('style'));

  	// Remove embedded <style>
  	doc.querySelector('style')?.remove();

  	// Rebuild each element with Renderer2
  	Array.from(doc.body.childNodes).forEach(node => {
	  const rebuilt = this.rebuildNode(node);
	  if (rebuilt) {
  			this.renderer.appendChild(container, rebuilt);
	  }
  	});
  }

  private rebuildNode(node: ChildNode): any {
  	// Handle text nodes
  	if (node.nodeType === Node.TEXT_NODE) {
	  return this.renderer.createText(node.textContent ?? '');
  	}

  	// Handle element nodes
  	if (node.nodeType === Node.ELEMENT_NODE) {
	  const element = node as HTMLElement;
	  const el = this.renderer.createElement(element.tagName.toLowerCase());

	  // Copy class list
	  if (element.classList && element.classList.length > 0) {
  			Array.from(element.classList).forEach(cls => this.renderer.addClass(el, cls));
	  }

	  // Copy other attributes (excluding style)
	  Array.from(element.attributes).forEach(attr => {
  			if (attr.name !== 'style') {
		  this.renderer.setAttribute(el, attr.name, attr.value);
  			}
	  });

	  // Recursively rebuild children
	  Array.from(node.childNodes).forEach(child => {
  			const rebuiltChild = this.rebuildNode(child);
  			if (rebuiltChild) {
		  this.renderer.appendChild(el, rebuiltChild);
  			}
	  });

	  return el;
  	}

  	return null;
  }

}
